import { coreInitiativesFilesGetAsyncSlice } from './get';
import { CoreInitiativesFilesName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteInitiativeFileRequest } from '@api';

export const coreInitiativesFilesRemoveSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesFilesName,
	state: coreInitiativesFilesGetAsyncSlice.asyncState,
	target: (request: DeleteInitiativeFileRequest) => (file) => file.id === request.id
});
